export default function getTagDefinitions(): string[] {
  return [];
}

export type TagPair = [position: string, tag: string];
/**
 * WIP
 */
export const getPowerInformationTagDefinitions = (): TagPair[] => {
  return [
    ['01NDB10U901', 'av'],
    ['NDB10CU010',  'av'],
    ['NDB31CU001',  'av'],
    ['NDE11FU002',  'av'],
    ['NDE11FU001',  'av'],
    ['3NPU01',      'av'],
    ['5NDB20FN001', 'av'],
    ['10NPU01',     'av'],
    ['11ND20CU901', 'av'],
    ['17N20CU001',  'av'],
    ['00100WQ01VP', 'av'],
    ['LAOU01',      'av'],
    ['30N10CU001',  'av'],
    ['20NDA30CU001','av'],
    ['31NDB22CU001','av'],
  ]
}
